import propTypes from 'prop-types';
import React, { useContext } from 'react';
import {
  CASH_REFUND_LINK_TEXT,
  VOUCHER_PROTECTED_CASH_REFUND_TIME_TEXT,
} from '../../config/text/text';
import { symbolFromCurrency } from '../../helpers/currency';
import ThemeContext from '../../providers/ThemeProvider';
import CTAButton from '../_generic/button/CTAButton';
import Paragraph from '../_generic/paragraph/Paragraph';

const CashRefund = ({ amount, handleCashRefund, currency }) => {
  const theme = useContext(ThemeContext);

  return (
    <div className="align-cash-section">
      <Paragraph textAlign={'center'}>
        {VOUCHER_PROTECTED_CASH_REFUND_TIME_TEXT}
      </Paragraph>
      <CTAButton
        className={'credit-refund-button'}
        onClick={() => handleCashRefund(true)}
        primaryAction={false}
      >
        {`${
          CASH_REFUND_LINK_TEXT[process.env.NEXT_PUBLIC_BRAND]
        } ${symbolFromCurrency(currency)}${amount}*`}
      </CTAButton>
      <style jsx>{`
        .custom-link {
          text-align: center;
          color: ${theme.colors.black};
        }
        .margin {
          margin-right: 2%;
        }
        .align-cash-section {
          text-align: center;
          justify-content: center;
          width: 50%;
        }
      `}</style>
    </div>
  );
};

CashRefund.propTypes = {
  amount: propTypes.number,
  currency: propTypes.string,
  handleCashRefund: propTypes.func,
};
export default CashRefund;
